<div class="bulk-create-container flex column">
  <div class="header flex row space-between align-items-baseline">
    <h3>Bulk schedule packager jobs</h3>
    <button
      type="button"
      class="dialog-close-btn"
      aria-label="Close"
      (click)="cancel()"
    >
      ×
    </button>
  </div>

  <div class="toolbar flex column">
    <div class="toolbar-row flex row wrap">
      <div class="toolbar-field">
        <span class="field-label">Search</span>
        <input
          class="filter-input"
          type="search"
          placeholder="Media name or ID"
          [(ngModel)]="nameFilter"
          (ngModelChange)="onFiltersChanged()"
          [disabled]="isLoading || isApplying"
        />
      </div>
      <div class="toolbar-field">
        <span class="field-label">Transcoding started after</span>
        <input
          class="filter-input"
          type="datetime-local"
          [(ngModel)]="transcodingStartedAfterFilter"
          (ngModelChange)="onFiltersChanged()"
          [disabled]="isLoading || isApplying"
        />
      </div>
      <div class="toolbar-field">
        <span class="field-label">Packager scheduled after</span>
        <input
          class="filter-input"
          type="datetime-local"
          [(ngModel)]="packagerScheduledAfterFilter"
          (ngModelChange)="onFiltersChanged()"
          [disabled]="isLoading || isApplying"
        />
      </div>
    </div>

    <div class="toolbar-row flex row wrap align-items-end">
      <button
        type="button"
        class="link-btn"
        [disabled]="isLoading || isApplying || filteredRows.length === 0"
        (click)="toggleSelectAll()"
      >
        {{ allFilteredSelected ? 'Clear selection' : 'Select all visible' }}
      </button>
      <div class="range-group flex row align-items-center">
        <span class="field-label">Rows</span>
        <input
          class="range-input"
          type="number"
          min="1"
          [(ngModel)]="rangeFrom"
          [disabled]="isLoading || isApplying"
        />
        <span>to</span>
        <input
          class="range-input"
          type="number"
          min="1"
          [(ngModel)]="rangeTo"
          [disabled]="isLoading || isApplying"
        />
        <button
          type="button"
          class="link-btn"
          [disabled]="isLoading || isApplying || filteredRows.length === 0"
          (click)="applyRangeSelection()"
        >
          Apply range
        </button>
      </div>
      <div class="mode-group flex row align-items-center">
        <span class="field-label">Set mode for selected:</span>
        <button
          type="button"
          class="mode-btn"
          [class.active]="setAllMode === packagingModes.Full"
          [disabled]="isApplying || selectedCount === 0"
          (click)="setModeForAllSelected(packagingModes.Full)"
        >
          Full
        </button>
        <button
          type="button"
          class="mode-btn"
          [class.active]="setAllMode === packagingModes.MetadataOnly"
          [disabled]="isApplying || selectedCount === 0"
          (click)="setModeForAllSelected(packagingModes.MetadataOnly)"
        >
          Metadata only
        </button>
      </div>
    </div>

    <label class="reschedule-toggle flex row align-items-center">
      <input
        type="checkbox"
        [(ngModel)]="rescheduleExisting"
        (ngModelChange)="onRescheduleExistingChanged()"
        [disabled]="isLoading || isApplying"
      />
      <span
        >Re-schedule already-scheduled media (reset to Ready, update mode)</span
      >
    </label>
  </div>

  <div class="table-wrapper" *ngIf="!isLoading; else loadingBlock">
    <table class="media-table" *ngIf="filteredRows.length > 0; else emptyBlock">
      <colgroup>
        <col class="col-check" />
        <col class="col-num" />
        <col class="col-media" />
        <col class="col-prefix" />
        <col class="col-profiles" />
        <col class="col-started" />
        <col class="col-packager-scheduled" />
        <col class="col-mode" />
        <col class="col-status" />
      </colgroup>
      <thead>
        <tr>
          <th class="col-check"></th>
          <th class="col-num">#</th>
          <th class="col-media">Media</th>
          <th class="col-prefix">Prefix</th>
          <th class="col-profiles">Profiles</th>
          <th class="col-started">Transcoding (UTC)</th>
          <th class="col-packager-scheduled">Packager (UTC)</th>
          <th class="col-mode">Mode</th>
          <th class="col-status">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of filteredRows; let i = index"
          [class.row-disabled]="isRowDisabled(row)"
        >
          <td class="col-check">
            <input
              type="checkbox"
              [checked]="row.selected"
              [disabled]="isApplying || isRowDisabled(row)"
              (change)="toggleRowSelection(row)"
            />
          </td>
          <td class="col-num">{{ i + 1 }}</td>
          <td class="col-media">
            <a [href]="'/mam/editMedia/' + row.mediaId" target="_blank">{{
              row.mediaName
            }}</a>
          </td>
          <td class="col-prefix" [title]="row.sourcePath">{{ row.sourcePath }}</td>
          <td class="col-profiles">{{ row.jobCount }}</td>
          <td class="col-started">{{ formatUtc(row.earliestStartTime) }}</td>
          <td class="col-packager-scheduled">
            <ng-container
              *ngIf="packagerScheduledAt(row) as scheduledAt; else noPackagerSchedule"
            >
              {{ formatUtc(scheduledAt) }}
            </ng-container>
            <ng-template #noPackagerSchedule>—</ng-template>
          </td>
          <td class="col-mode">
            <div class="mode-toggle flex row">
              <button
                type="button"
                class="mode-btn"
                [class.active]="row.mode === packagingModes.Full"
                [disabled]="isApplying"
                (click)="setRowMode(row, packagingModes.Full)"
              >
                Full
              </button>
              <button
                type="button"
                class="mode-btn"
                [class.active]="row.mode === packagingModes.MetadataOnly"
                [disabled]="isApplying"
                (click)="setRowMode(row, packagingModes.MetadataOnly)"
              >
                Metadata
              </button>
            </div>
          </td>
          <td class="col-status">
            <ng-container *ngIf="row.existingCount > 0; else noStatus">
              <span class="status-badge">{{ row.existingStatus }}</span>
              <span class="mode-hint"
                >({{ existingModeLabel(row.existingFullMode) }})</span
              >
            </ng-container>
            <ng-template #noStatus>—</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #loadingBlock>
    <p class="state-message">Loading eligible media...</p>
  </ng-template>

  <ng-template #emptyBlock>
    <p class="state-message">No eligible media found for this tenant.</p>
  </ng-template>

  <div class="footer flex row space-between align-items-center">
    <span class="selection-summary">
      {{ selectedCount }} selected<span *ngIf="metadataOnlySelectedCount > 0">
        ({{ metadataOnlySelectedCount }} metadata-only)</span
      >
      <span *ngIf="filteredRows.length !== rows.length">
        · {{ filteredRows.length }} shown of {{ rows.length }}</span
      >
    </span>
    <div class="footer-actions flex row">
      <evrideo-hover-button
        [backgroundColor]="'white'"
        [hoverClass]="'transparent'"
        [color]="'black'"
        [border]="'1px solid black'"
        (click)="cancel()"
      >
        <span>Cancel</span>
      </evrideo-hover-button>
      <evrideo-hover-button (click)="apply()">
        <span>{{ isApplying ? 'Scheduling...' : 'Schedule' }}</span>
      </evrideo-hover-button>
    </div>
  </div>
</div>
